<template>
    <div class="mt-2" v-if="ready">
        <b-card header-tag="header" footer-tag="footer" class="d-flex mb-2 min-330">
            <template #header>
                <!--<h6 class="mb-0">{{ title }}</h6>-->
                <b-row class="pb-2">
                    <b-col class="col-7 text-start">
                        <span><small><b>{{ title }}</b></small></span>
                    </b-col>
                    <b-col class="col-5 text-end">
                        <span class="badge badge-unknown pointer" @click="toggleFooter">
                            Details
                        </span>
                        <button type="button" class="btn btn-light btn-sm" @click="refresh()">
                            <i class="fa-solid fa-arrows-rotate">
                            </i>
                        </button>
                    </b-col>
                </b-row>
            </template>
            <b-card-body>
                <loading v-model:active="isLoading"
                         :is-full-page="fullPage"/>
                <div class="d-flex justify-content-between">
                    <div>
                        <div class="ebox">
                            <v-chart :option="echartTotalOptions"/>
                        </div>
                    </div>
                    <div>
                        <div class="text-center ebox" @click="goTo('down', 'down')">
                            <v-chart :option="echartDownOptions"/>
                        </div>
                    </div>
                    <div>
                        <div class="ebox" @click="goTo('unreachable', 'unreachable')">
                            <v-chart :option="echartUnreachableOptions"/>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <template #footer v-if="showFooter">
                <div class="d-flex justify-content-between">
                    <div class="col-4">
                        <div class="bold mb-4 mleft--10">
                            <small class="fsize10"><i class="fa-solid fa-triangle-exclamation warning"></i>
                                {{ $t('unhandled') }}
                            </small>
                        </div>
                        <div class="bold mb-4  mleft--10">
                            <small class="fsize10"><i class="fa-solid fa-user"></i> {{ $t('Acknowledged') }}</small>
                        </div>
                        <div class="bold mb-4 mleft--10">
                            <small class="fsize10"><i class="fa-solid fa-power-off"></i> {{ $t('In downtime') }}</small>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="mb-4">
                            <b-badge pill variant="danger" class="w-100" :class="[not_handled[1] > 0 ? 'pointer': '']"
                                     @click="goTo('down', 'not_handled')"><i
                                class="fa-solid fa-triangle-exclamation warning"></i> {{ not_handled[1] }}
                            </b-badge>
                        </div>
                        <div class="mb-4">
                            <b-badge pill variant="danger" class="w-100" :class="[acknowledged[1] > 0 ? 'pointer': '']"
                                     @click="goTo('down', 'acknowledged')"><i class="fa-solid fa-user"></i>
                                {{ acknowledged[1] }}
                            </b-badge>
                        </div>
                        <div class="mb-4">
                            <b-badge pill variant="danger" class="w-100" :class="[downtimes[1] > 0 ? 'pointer': '']"
                                     @click="goTo('down', 'downtimes')"><i class="fa-solid fa-power-off"></i>
                                {{ downtimes[1] }}
                            </b-badge>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="secondary" class="w-100"
                                     :class="[not_handled[2] > 0 ? 'pointer': '']"
                                     @click="goTo('unreachable', 'not_handled')"><i
                                class="fa-solid fa-triangle-exclamation warning"></i>
                                {{ not_handled[2] }}
                            </b-badge>
                        </div>
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="secondary" class="w-100"
                                     :class="[acknowledged[2] > 0 ? 'pointer': '']"
                                     @click="goTo('unreachable', 'acknowledged')"><i class="fa-solid fa-user"></i>
                                {{ acknowledged[2] }}
                            </b-badge>
                        </div>
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="secondary" class="w-100" :class="[downtimes[2] > 0 ? 'pointer': '']"
                                     @click="goTo('unreachable', 'downtimes')"><i class="fa-solid fa-power-off"></i>
                                {{ downtimes[2] }}
                            </b-badge>
                        </div>
                    </div>
                </div>
            </template>
        </b-card>
    </div>
</template>

<script>
//import * as echarts from 'echarts/core';
import "echarts-liquidfill"
import VChart from 'vue-echarts';
import { BBadge } from 'bootstrap-vue-next';
import router from '../../router';
import Loading from 'vue-loading-overlay';

export default {
    name: "TacticalHostWidget",
    components: {
        BBadge,
        VChart,
        Loading
    },
    props: ['title', 'widget_id', 'theme'],
    data() {
        return {
            isLoading: false,
            fullPage: false,
            ready: false,
            showFooter: false,
            permissions: {},
            widgetData: {},
            stateSummary: [],
            not_handled: [],
            acknowledged: [],
            downtimes: [],
            totalSeries: [],
            down: [],
            unreachable: [],
            total: 0,
            hostsFilter: {
                filter: {
                    id: []
                }
            },
            echartTotalOptions: {
                series: [{
                    type: 'liquidFill',
                    name: 'liquidFill',
                    radius: "100%",
                    data: [0, 0, 0],
                    color: ['#00ea5f', '#ff4444', '#CFCFCF'],
                    waveAnimation: false,
                    amplitude: 0,
                    // animationDuration: 2000,
                    // animationDurationUpdate: 2000,
                    // animationEasingUpdate: 'cubicOut',
                    // phase: 0,
                    // period: 5000,

                    backgroundStyle: {
                        borderWidth: 5,
                        color: '#706b6b'
                        // borderColor: 'red',
                    },
                    outline: {
                        show: false,
                        borderDistance: 3,
                        itemStyle: {
                            borderColor: "#CC0000",
                            borderWidth: 3
                        }
                    },
                    label: {
                        show: true,
                        color: "white",
                        insideColor: "white",
                        fontSize: 12,
                        fontWeight: "bold",
                        formatter: function(param) {
                            return 'Total' + '\n' + param.seriesName;
                        }
                    }
                }]
            },
            echartDownOptions: {
                series: [
                    {
                        type: "liquidFill",
                        name: "Liquid Fill",
                        radius: "100%",
                        data: [0],
                        period: 5000,
                        label: {
                            color: "white",
                            insideColor: "white",
                            fontSize: 12,
                            fontWeight: "bold",
                            formatter: function(param) {
                                return 'Down' + '\n' + param.seriesName + '\n' + '(' + parseInt(param.value * 100) + '%)';
                            }
                        },
                        color: ['#CC0000'],
                        outline: {
                            show: false,
                            borderDistance: 3,
                            itemStyle: {
                                borderColor: "#CC0000",
                                borderWidth: 3
                            }
                        },
                        backgroundStyle: {
                            borderWidth: 5,
                            // borderColor: 'red',
                            color: 'rgba(255, 99, 71, 0.5)'
                        }
                    }
                ]

            },
            echartUnreachableOptions: {
                series: [
                    {
                        type: "liquidFill",
                        name: "Liquid Fill",
                        radius: "100%",
                        data: [0],
                        period: 5000,
                        label: {
                            color: "white",
                            insideColor: "white",
                            fontSize: 12,
                            fontWeight: "bold",
                            formatter: function(param) {
                                return 'Unr.' + '\n' + param.seriesName + '\n' + '(' + parseInt(param.value * 100) + '%)';
                            }
                        },
                        color: ['#868e96'],
                        outline: {
                            show: false,
                            borderDistance: 3,
                            itemStyle: {
                                borderColor: "#CC0000",
                                borderWidth: 3
                            }
                        },
                        backgroundStyle: {
                            borderWidth: 5,
                            // borderColor: 'red',
                            color: 'LightGray'
                        }
                    }
                ]
            }
        }
    },
    async mounted() {
        this.permissions = this.$store.state.permissions;
        this.getWidget();
    },
    methods: {
        toggleFooter: function() {
            this.showFooter = !this.showFooter;
        },
        refresh: function() {
            this.getWidget();
        },
        getWidget: function() {
            this.isLoading = true;
            axios.post('/dashboards/getTacticalOverviewWidget.json', null, {
                params: {
                    type: 'hosts',
                    id: this.widget_id
                }
            }).then(result => {
                this.widgetData = result.data.widgetData;
                this.total = this.widgetData.hoststatusSummary.total;
                this.stateSummary = this.widgetData.hoststatusSummary.state;
                const up = parseInt(this.widgetData.hoststatusSummary.state[0] / this.total * 100);
                const down = parseInt(this.widgetData.hoststatusSummary.state[1] / this.total * 100);
                const unreachable = parseInt(this.widgetData.hoststatusSummary.state[2] / this.total * 100);
                this.down = [down];
                this.unreachable = [unreachable]
                this.totalSeries = [
                    up,
                    down,
                    unreachable
                ];
                let sortArray = [
                    {key: '#00ea5f', value: up},
                    {key: '#ff4444', value: down},
                    {key: '#CFCFCF', value: unreachable}
                ]
                sortArray.sort((a, b) => b.value - a.value);
                this.echartTotalOptions.series[0].data = [sortArray[0].value / 100, sortArray[1].value / 100, sortArray[2].value / 100];
                this.echartTotalOptions.series[0].color = [sortArray[0].key, sortArray[1].key, sortArray[2].key];
                this.echartTotalOptions.series[0].name = ( this.total ).toString();
                this.echartDownOptions.series[0].data = [down / 100];
                this.echartDownOptions.series[0].name = ( this.stateSummary[1] ).toString();
                this.echartUnreachableOptions.series[0].data = [unreachable / 100];
                this.echartUnreachableOptions.series[0].name = ( this.stateSummary[2] ).toString();
                this.not_handled = this.widgetData.hoststatusSummary.not_handled;
                this.acknowledged = this.widgetData.hoststatusSummary.acknowledged;
                this.downtimes = this.widgetData.hoststatusSummary.in_downtime;
                setTimeout(() => {
                    this.ready = true;
                }, 200);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.isLoading = false;
            });

        },
        goTo: function(state, type) {

            switch(state) {
                case 'all': {
                    const combined = [].concat(this.stateSummary.hostIds[0], this.stateSummary.hostIds[1], this.stateSummary.hostIds[2]);
                    if(combined.length > 0) {
                        this.hostsFilter.filter.id = combined;
                        this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                        router.push({name: 'hostsIndexFilter'});
                    }
                    break;
                }
                case 'down': {
                    switch(type) {
                        case 'down': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.stateSummary.hostIds[1].length > 0) {
                                this.hostsFilter.filter.id = this.stateSummary.hostIds[1];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        case 'not_handled': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.not_handled.hostIds[1].length > 0) {
                                this.hostsFilter.filter.id = this.not_handled.hostIds[1];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        case 'acknowledged': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.acknowledged.hostIds[1].length > 0) {
                                this.hostsFilter.filter.id = this.acknowledged.hostIds[1];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        case 'downtimes': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.downtimes.hostIds[1].length > 0) {
                                this.hostsFilter.filter.id = this.downtimes.hostIds[1];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
                case 'unreachable': {
                    switch(type) {
                        case 'unreachable': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.stateSummary.hostIds[2].length > 0) {
                                this.hostsFilter.filter.id = this.stateSummary.hostIds[2];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        case 'not_handled': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.not_handled.hostIds[2].length > 0) {
                                this.hostsFilter.filter.id = this.not_handled.hostIds[2];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        case 'acknowledged': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.acknowledged.hostIds[2].length > 0) {
                                this.hostsFilter.filter.id = this.acknowledged.hostIds[2];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        case 'downtimes': {
                            if(!this.hostPermissions) {
                                break;
                            }
                            if(this.downtimes.hostIds[2].length > 0) {
                                this.hostsFilter.filter.id = this.downtimes.hostIds[2];
                                this.$store.commit('setHostsIndexFilter', this.hostsFilter);
                                router.push({name: 'hostsIndexFilter'});
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        }

    },
    computed: {
        hostPermissions: function() {
            return !!( this.permissions.hosts && this.permissions.hosts.index );
        }
    }
}
</script>

<style scoped>
.max-550 {
    max-width: 550px !important;
}

.min-330 {
    min-width: 330px !important;
}

.fsize10 {
    font-size: 10px;
}

.pointer {
    cursor: pointer;
}

.ebox {
    width: 60px;
    height: 60px;
}

.mleft--10 {
    margin-left: -10px;
}
</style>
